module.exports = __webpack_public_path__ + "static/media/019.1dd309cb.jpg";